import React from 'react';
import { motion } from 'framer-motion';

const PrivacyClassicVerse = () => {
  return (
    <div className="pt-24 pb-20 max-w-3xl mx-auto px-4 sm:px-6 lg:px-8 legal-content">
      <motion.div initial={{ opacity: 0 }} animate={{ opacity: 1 }}>
        <span className="text-accent-orange font-semibold tracking-wider text-sm uppercase mb-2 block">App Specific Policy</span>
        <h1>ClassicVerse Privacy Policy</h1>
        <p className="text-sm border-l-2 border-accent-orange pl-4 mb-8">
          Last Updated: March 2026
        </p>

        <p>
          This document outlines the specific privacy practices for <strong>ClassicVerse</strong>, our public domain film player. It serves as an addendum to the general MediaVerse Labs Privacy Policy.
        </p>

        <h2>1. Zero Data Collection</h2>
        <p>
          ClassicVerse does not collect, transmit, or store any personal information on our servers. We do not track which films or shows you watch.
        </p>

        <h2>2. Local Data Storage</h2>
        <p>
          All data related to ClassicVerse is stored entirely locally on your Windows device. This data is stored in your user's AppData directory: <code>%APPDATA%\ClassicVerse</code>. This includes:
        </p>
        <ul>
          <li>Your watchlist and "continue watching" progress.</li>
          <li>Favorite categories and genres.</li>
          <li>Application settings and playback preferences.</li>
        </ul>

        <h2>3. Network Connections</h2>
        <p>
          ClassicVerse only makes network requests necessary for its core functionality:
        </p>
        <ul>
          <li><strong>Content Streaming:</strong> Connecting directly to the public domain archives where the films are hosted.</li>
          <li><strong>Metadata:</strong> Fetching film descriptions, posters, and cast information from public movie databases.</li>
        </ul>

        <h2>4. No Analytics, Telemetry, or Cookies</h2>
        <p>
          There is no telemetry, analytics code, or cookies embedded within ClassicVerse. Your usage remains 100% private.
        </p>

        <h2>5. Contact</h2>
        <p>
          For privacy inquiries: <a href="mailto:hello@mediaverselabs.com">hello@mediaverselabs.com</a>
        </p>
      </motion.div>
    </div>
  );
};

export default PrivacyClassicVerse;